import { render, staticRenderFns } from "./dispatcherArea.vue?vue&type=template&id=db271fdc&scoped=true"
import script from "./dispatcherArea.vue?vue&type=script&lang=js"
export * from "./dispatcherArea.vue?vue&type=script&lang=js"
import style0 from "./dispatcherArea.vue?vue&type=style&index=0&id=db271fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db271fdc",
  null
  
)

export default component.exports